export default class QueryOrderByItem
{
	remoteClass = "gongqi.erp.gotmodel.sqlquery.QueryOrderByItem";

	tableId;	//String
	fieldId;	//String
	fieldName;	//String
	fieldType;	//String

	orderBy;	//String			//QueryOrderByType
	type;

}


// WEBPACK FOOTER //
// ./src/universalView/remote/QueryOrderByItem.js